import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import VantaBackground from './componets/vantabackground';



const ProTraderFreeTool = () => {
  /* Unused form logic removed as this page now links to external platform */

  return (
    <>
      {/* CSS for better navigation sizing and dropdown visibility */}
      <style>{`
        /* Container styling */
        .protrader-page-container {
          position: relative;
          min-height: 100vh;
          width: 100%;
        }

        /* Fix hamburger button size */
        .hamburger-btn {
          width: 40px !important;
          height: 40px !important;
          padding: 8px !important;
        }

        .hamburger-icon {
          width: 20px !important;
          height: 15px !important;
        }

        .hamburger-icon span {
          height: 2px !important;
        }

        /* Fix select dropdown visibility */
        .glass-input select {
          color: white !important;
          background: rgba(255, 255, 255, 0.1) !important;
        }

        .glass-input select option {
          background: rgba(0, 0, 0, 0.95) !important;
          color: white !important;
          padding: 10px !important;
          border: none !important;
        }

        .glass-input select option:hover,
        .glass-input select option:focus {
          background: rgba(66, 126, 234, 0.8) !important;
          color: white !important;
        }

        /* Alternative: Style all select elements in the form */
        select {
          color: white !important;
        }

        select option {
          background: rgba(0, 0, 0, 0.95) !important;
          color: white !important;
          padding: 8px 12px !important;
        }

        select option:hover,
        select option:checked {
          background: rgba(66, 126, 234, 0.8) !important;
          color: white !important;
        }

        /* Responsive sizing */
        @media (max-width: 768px) {
          .hamburger-btn {
            width: 36px !important;
            height: 36px !important;
            padding: 6px !important;
          }

          .hamburger-icon {
            width: 18px !important;
            height: 14px !important;
          }
        }
      `}</style>

      <div className="protrader-page-container relative w-full font-sans">
        {/* Vanta Background */}
        <div className="fixed inset-0 z-0" style={{ pointerEvents: 'none' }}>
          <VantaBackground
            color={0x0d47a1}
            backgroundColor={0x000000}
            scale={1.4}
            scaleMobile={1.0}
          />
        </div>

      {/* Gradient Overlay */}
      <div className="fixed inset-0 z-[1] bg-gradient-to-b from-black/80 via-black/70 to-black/80" />

      {/* Additional overlay for better text contrast */}
      <div className="fixed inset-0 z-[2] bg-black/40" />

      {/* Back Button */}
      <Link
        to="/free-tools"
        className="fixed top-24 left-4 z-[999] glass-btn glass-btn-secondary px-3 py-2 text-sm flex items-center gap-2 hover:scale-105 transition-transform"
      >
        <span>←</span>
        <span className="hidden sm:inline">Back to Tools</span>
        <span className="sm:hidden">Back</span>
      </Link>

      {/* Main Content */}
      <div className="relative z-[10] min-h-full pt-32 pb-32 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">

          {/* Left Side - Tool Info */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center lg:text-left"
          >
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-emerald-500 px-4 py-2 rounded-full text-white font-bold mb-6">
              <span className="text-xl">🎁</span>
              <span>100% FREE TOOL</span>
            </div>

            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent font-orbitron leading-tight">
              ProTrader Visual Journal
            </h1>

            <p className="text-sm sm:text-base lg:text-lg text-gray-300 mb-4 sm:mb-6 max-w-xl text-left" style={{textShadow: '0 1px 2px rgba(0,0,0,0.6)'}}>
              Get our professional-grade trading journal EA absolutely FREE when you sign up with one of our partner brokers.
            </p>

            {/* Key Features */}
            <div className="space-y-2 mb-4">
              {[
                'Real-time trading dashboard with P&L tracking',
                'Automatic chart screenshots on every trade',
                'Google Sheets integration for trade logging',
                'Telegram remote control & alerts',
                'Advanced risk management tools',
                'Performance analytics & metrics'
              ].map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2 + index * 0.1 }}
                  className="flex items-center gap-3 text-gray-300 text-sm lg:text-base"
                >
                  <span className="text-green-400 text-xl">✅</span>
                  <span>{feature}</span>
                </motion.div>
              ))}
            </div>

            <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-3 sm:p-4 lg:p-6 backdrop-blur-sm">
              <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-blue-400 mb-2">What You Get:</h3>
              <div className="text-gray-300 text-xs sm:text-sm lg:text-base space-y-1">
                <div>✨ ProTrader Visual Journal MT5 EA</div>
                <div>📋 Complete setup instructions</div>
                <div>🎯 Personal onboarding call</div>
                <div>💎 Worth $297 - Yours FREE!</div>
              </div>
            </div>
          </motion.div>

          {/* Right Side - Sign Up CTA */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="glass-card glass-card-large w-full"
          >
            <div className="text-center mb-4 sm:mb-6">
              <h2 className="glass-card-title text-lg sm:text-xl lg:text-2xl mb-2">
                Claim Your Free Tool
              </h2>
              <p className="glass-card-text text-xs sm:text-sm">
                Sign up on our dedicated ProTrader platform
              </p>
            </div>

            <div className="space-y-4">
              <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4 backdrop-blur-sm">
                <h3 className="text-sm sm:text-base font-semibold text-blue-400 mb-2">What Happens Next:</h3>
                <div className="text-gray-300 text-xs sm:text-sm space-y-2">
                  <div className="flex items-start gap-2">
                    <span className="text-green-400 mt-0.5">1️⃣</span>
                    <span>Sign up on the ProTrader platform</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-green-400 mt-0.5">2️⃣</span>
                    <span>Choose your preferred broker</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-green-400 mt-0.5">3️⃣</span>
                    <span>Get instant access to your free tool</span>
                  </div>
                </div>
              </div>

              {/* Sign Up Button */}
              <motion.a
                href="https://protrader.ksquants.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="glass-btn glass-btn-primary w-full text-sm sm:text-base py-4 block text-center"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <span className="flex items-center justify-center gap-2">
                  <span className="text-xl">🚀</span>
                  Sign Up for ProTrader
                </span>
              </motion.a>

              <div className="text-center">
                <p className="glass-card-text text-xs">
                  🔒 Secure signup on our dedicated ProTrader platform
                </p>
              </div>
            </div>
          </motion.div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default ProTraderFreeTool;